import accountManagementEpics from './accountManagementEpics';

const epics = [accountManagementEpics];

export default epics;
